export const RESET = 'EXSBBATCHNUMBER_UPDATE_RESET'
export const SET_ERROR = 'EXSBBATCHNUMBER_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBBATCHNUMBER_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBBATCHNUMBER_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBBATCHNUMBER_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBBATCHNUMBER_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBBATCHNUMBER_UPDATE_UPDATE_RETRIEVED'
